import React, { useCallback, useEffect, useState } from 'react';
import { API_ROUTES } from 'src/config/api';

import { Auth } from 'aws-amplify';
import Axios from 'axios';
import { PencilIcon } from '@heroicons/react/24/outline';
import { RSelect } from 'src/components/Component';
import Skeleton from 'react-loading-skeleton'

import 'react-loading-skeleton/dist/skeleton.css'

const OrganisationInformation = ({ organisation }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [avaiableEdit, setAvailableEdit] = useState([]);
  const [editingProvider, setEditingProvider] = useState(null);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [dropdownValue, setDropdownValue] = useState(null);
  const [submitting, setSubmitting] = useState(null);

  const editBanding = (payment_provider_id) => {
    // Set the dropdown options
    let options = data.available.filter((item) => item.payment_provider_id === payment_provider_id).map((item) => ({ value: item.id, label: item.name }));
    setDropdownOptions(options);

    // Set the dropdown value
    const value = data.current.filter((item) => item.payment_provider_id === payment_provider_id);

    if (value.length > 0) {
      setDropdownValue({ value: value[0].band_id, label: value[0].band_name });
    }

    // Set the editing provider
    setEditingProvider(payment_provider_id);
  }

  const saveBanding = useCallback(async (providerID) => {
    const user = await Auth.currentAuthenticatedUser();

    setSubmitting(providerID);

    const current = data.current.filter((item) => item.payment_provider_id === providerID);

    // Fetch the data
    await Axios(
      API_ROUTES.payment['organisation:bandings:get'](organisation.organisation),
      {
        method: 'put',
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
        data: {
          current_id: current.length > 0 ? current[0].id : null,
          band_id: dropdownValue.value,
          payment_provider_id: providerID,
        }
      }
    );

    await fetchBandings();
  });

  const fetchBandings = useCallback(async () => {
    const user = await Auth.currentAuthenticatedUser();

    // Fetch the data
    const result = await Axios(
      API_ROUTES.payment['organisation:bandings:get'](organisation.organisation),
      {
        method: 'get',
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
      }
    );

    // Set the data
    setData(result.data.data);
    setLoading(false);
    setSubmitting(null);
    setEditingProvider(null);

    // Set what banding edit is availalble for payment providers
    let seenAvailable = []
    result.data.data.available.forEach((item) => {
      if (!seenAvailable.includes(item.payment_provider_id)) {
        seenAvailable.push(item.payment_provider_id);
      }
    });

    setAvailableEdit(seenAvailable);
  }, [organisation]);

  useEffect(() => {
    fetchBandings();
  }, [organisation]);

  return (
    <div>

      <h3 className="font-extralight uppercase font-mono text-2xl dark:text-white text-violet-900 mb-4 border-b border-violet-900 pb-2">
        Banding
      </h3>

      <div className="clearfix h-auto">
        {loading === true && (
          <div className='mt-2 mb-2'>
            <Skeleton count={3} height="50px" className="mt-1 mb-1" style={{
              width: '100%',
            }} />
          </div>
        )}

        {loading === false && (
          <table className='w-full my-2'>
            <tbody>
              {loading === false && data.current.length === 0 && (
                <tr>
                  <td className="py-2 font-bold col-span-2 text-center text-red-800">
                    No Payment Providers Setup
                  </td>
                </tr>
              )}
              {loading === false && data.current.map((banding, index) => (
                <tr key={index}>
                  <td className="py-2 font-bold">
                    {banding.payment_provider_name}
                  </td>
                  <td className="text-gray-700 pl-4 py-2 text-right">
                    {submitting !== banding?.payment_provider_id && editingProvider === banding?.payment_provider_id && (
                      <RSelect
                        isClearable
                        name="parent"
                        id="parent"
                        className="form-control form-control-md p-0 border-0 indicator-hidden"
                        value={dropdownValue}
                        options={dropdownOptions}
                        onChange={(i) => setDropdownValue(i)}
                        placeholder=""
                        classNamePrefix="react-select"
                      />
                    )}
                    {submitting !== banding?.payment_provider_id && editingProvider !== banding?.payment_provider_id &&
                      (banding?.band_name || (avaiableEdit.includes(banding?.payment_provider_id) ? 'No Banding Set' : 'No Provider Bandings Available'))
                    }
                    {submitting === banding?.payment_provider_id && (
                      <Skeleton count={1} height="30px" style={{
                        width: '100%',
                      }} />
                    )}

                  </td>
                  {submitting !== banding?.payment_provider_id && avaiableEdit.includes(banding?.payment_provider_id) && (
                    <td className="text-right">
                      {editingProvider !== banding?.payment_provider_id && (
                        <PencilIcon className="inline h-4 w-4 -mt-2 hover:text-blue-800 text-violet-800 cursor-pointer" onClick={() => editBanding(banding?.payment_provider_id)} />
                      )}
                      {banding?.payment_provider_id === editingProvider && (
                        <button type="submit" onClick={() => saveBanding(banding?.payment_provider_id)} className="btn btn-md btn-primary bg-violet-800 mt-[0.5px]">Save</button>
                      )}

                    </td>
                  )}
                </tr>
              ))}
            </tbody>

          </table>
        )}
      </div>
    </div>
  );
}

export default OrganisationInformation;